/**
 * pagination.js
 */

// Import
import "./pagination.scss";
import $ from 'jquery';

$(document).ready(function() {

});